<div class="wrapper">
    <!-- form add & edit -->
    <div class="main-menu">
        <!-- Sửa menu -->
        <div class="select-link-page">
            <!-- Nhóm (group) -->
            <div *ngIf="data.item.level == 0" class="content-left">
                <nz-radio-group style="display:grid;gap: 5px;margin-top: 15px;"
                    [(ngModel)]="data.item.group"
                    (ngModelChange)="onChangeAttr()">
                    <ng-container *ngFor="let item of listGroupLink">
                        <label nz-radio *ngIf="data.groups.includes(item.url)" [nzValue]="item.url">{{item.name| translate}}</label>
                    </ng-container>
                </nz-radio-group>
            </div>
            <div class="content-right">
                <!-- Danh sách loại link -->
                <div class="fill-name-menu">
                    <nz-radio-group nzName="radiogroup"
                        [(ngModel)]="data.item.type"
                        (ngModelChange)="onChangeAttr()">
                        <label nz-radio *ngFor="let link of listLink" [nzValue]="link.url">{{link.name| translate}}</label>
                    </nz-radio-group>
                </div>
                <!-- Tên menu -->
                <div class="fill-name-menu">
                    <p class="title-name">{{'ten_menu' | translate}}</p>
                    <div style="display: flex; justify-content: center; align-items: center; gap: 12px;">
                        <input class="field-fill" nz-input placeholder="{{'nhap_ten_menu' | translate}}"
                            [(ngModel)]="data.item['name_' + functionService.languageTempCode]"
                            (input)="onChangeAttr()" />
                        <button *ngIf="isAutoTranslate && functionService.multi_languages.length > 1"
                            type="submit" class="btn btn-warning" (click)="autoTranslateNameLang()" 
                            [disabled]="!data.item['name_' + functionService.languageTempCode]"
                            [ngStyle]="{opacity: !data.item['name_' + functionService.languageTempCode] ? .5: 1}">
                            {{'dich' | translate}}
                        </button>
                        <!-- Chọn ngôn ngữ -->
                        <div>
                            <app-select-language-config [isAdmin]="true"></app-select-language-config>
                        </div>
                    </div>
                </div>
                <!-- Nhóm: Đường dẫn (link) -->
                <div class="connect-page">
                    <!-- Chọn liên kết loại Không (none) -->
                    <div class="group-link">
                    </div>
                    <!-- Chọn liên kết loại Đến trang (link-page) -->
                    <div class="group-link" *ngIf="data.item.type == 'link-page'">
                        <!-- Link-page -->
                       <div class="fill-name-menu">
                        <p class="title-name">{{'duong_dan_lien_ket' | translate}}:</p>
                            <div class="elementor-select">
                                <input nz-input class="field-fill" placeholder="/ten-trang-chi-tiet-san-pham/ten-san-pham"
                                    style="border-top-left-radius: 0px; border-bottom-left-radius: 0px"
                                    [(ngModel)]="data.item.link_page"
                                    (input)="onChangeAttr()" />
                            </div>
                        </div>
                    </div>
                    <!-- Chọn liên kết loại Liên kết (website) -->
                    <div class="group-link" *ngIf="data.item.type == 'website'">
                        <!-- Liên kết Website -->
                        <div class="fill-name-menu">
                            <p class="title-name">{{'lien_ket_website_khac' | translate}}:</p>
                            <div class="elementor-select">
                                <input nz-input class="field-fill"[placeholder]="'https://viethas.com'"
                                    style="border-top-left-radius: 0px;border-bottom-left-radius: 0px;"
                                    [(ngModel)]="data.item.link_website"
                                    (input)="onChangeAttr()" />
                            </div>
                        </div>
                    </div>

                    <div class="fill-name-menu"  *ngIf="data.item.type == 'link-page' || data.item.type == 'none'">
                        <p class="title-name">{{'hanh_dong_khi_nhan' | translate}}:</p>
                        <div class="elementor-select mb-2">
                            <nz-select nzAllowClear class="field-fill" style="width:100%"
                                [nzPlaceHolder]="'cuon_len_dau_trang' | translate"
                                [(ngModel)]="data.item.click_action"
                                (ngModelChange)="onChangeAttr()">
                                <nz-option [nzLabel]="'cuon_len_dau_trang' | translate" [nzValue]="'scroll_to_top'"></nz-option>
                                <nz-option [nzLabel]="'giu_nguyen_vi_tri' | translate" [nzValue]="'keep_position'"></nz-option>
                                <nz-option [nzLabel]="'cuon_den_khoi' | translate" [nzValue]="'scroll_to_block'"></nz-option>
                            </nz-select>
                        </div>
                        <div  *ngIf="data.item.click_action == 'scroll_to_block'"> 

                             <nz-select [(ngModel)]="data.item.scroll_block_id" nzAllowClear nzPlaceHolder="Choose" nzShowSearch [nzPlaceHolder]="'chon_khoi_cuon_den' | translate">
                                <nz-option-group *ngFor="let gr of data.blocks_of_page" nzLabel="{{gr['name_' + functionService.languageTempCode]}}">
                                    <nz-option  *ngFor="let block of gr.blocks" [nzLabel]="block.name | translate" [nzValue]="block._id"></nz-option>
                                </nz-option-group>
                            </nz-select>

                            <div class="form-group">
                                <label for="scrollDistance">{{'khoang_cach_chua_ra_de_tranh_menu_co_dinh' | translate }}</label>
                                <input type="number" nz-input class="field-fill" 
                                [(ngModel)]="data.item.scroll_distance"
                                (input)="onChangeAttr()" />
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Nhóm: Gọi danh mục (category) -->
                <div class="connect-category" *ngIf="data.item.group == 'category'  || data.item.group == 'pop-up-subcategory'">
                    <div class="group-link">
                        <!-- Các danh mục con sẽ dẫn tới trang -->
                        <div class="fill-name-menu">
                            <p class="title-name">{{'cac_danh_muc_con_se_dan_toi_trang' | translate}}: </p>
                            <div class="elementor-select">
                                <nz-select nzAllowClear class="field-fill" [nzPlaceHolder]="'chon_trang_danh_muc' | translate"
                                    [(ngModel)]="data.item.id_page_category"
                                    (ngModelChange)="onChangeAttr()">
                                    <nz-option *ngFor="let page of listPageCategory"
                                        [nzLabel]="page['name_' + functionService.languageTempCode]"
                                        [nzValue]="page.link"></nz-option>
                                </nz-select>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Nhóm: Gọi hộp thoại (pop-up) -->
                <div class="connect-popup" *ngIf="data.item.group == 'pop-up'  || data.item.group == 'pop-up-subcategory'" style="display: flex; align-items: flex-end; gap: 20px; margin-top: 15px">
                    <!-- Hộp thoại -->
                    <div class="fill-name-menu">
                        <p class="title-name">{{'hop_thoai' | translate}}: </p>
                        <nz-select nzAllowClear class="field-fill" nzPlaceHolder="{{'chon_hop_thoai_hien_thi' | translate}}"
                            [(ngModel)]="data.item.id_freeblock"
                            (ngModelChange)="onChangeAttr()">
                            <nz-option *ngFor="let block of listBlockPopup"
                                [nzValue]="block._id"
                                [nzLabel]="block.name"></nz-option>
                        </nz-select>
                    </div>
                    <button *ngIf="type != 'build'" nz-button nzType="primary" (click)="createNewBlock()">{{'tao_hop_thoai' | translate}}</button>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="button-add" style="display:flex;align-items: center;justify-content: flex-end;gap:5px;margin-top: 15px;">
    <button nz-button (click)="cancelFormEditMenu()">{{'huy' | translate}}</button>
    <button nz-button nzType="primary" [disabled]="!isValid" (click)="saveFormEditMenu()">{{'luu' | translate}}</button>
</div>